import { Component } from '@angular/core'
import { AuthyService } from '../../../../../modules/auth/services/authy.service'
import { Router } from '@angular/router'
import { AuthService } from '../../../../../auth.service';

@Component({
  selector: 'cui-topbar-profile-menu',
  templateUrl: './profile-menu.component.html',
  styleUrls: ['./profile-menu.component.scss'],
})
export class TopbarProfileMenuComponent {
  badgeCount: number = null
  userName: string
  billingPlan: string
  email: string
  phone: string
  role: string

  constructor(
    public _authyService: AuthyService,
    public _authService: AuthService,
    public router: Router,
    ) {
    // const userInfo:any = this._authService.getLocalUser()
  }

  badgeCountIncrease() {
    // this.badgeCount = this.badgeCount + 1
  }

  logout() {
    this._authyService.removeLocalStatus()
    this.router.navigate(['/auth']);
  }
}
